/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs */

const en_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This can take a minute - we are calculating smart layouts for your photos.`)
};

const es_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto puede tardar un minuto - estamos calculando diseños inteligentes para tus fotos.`)
};

const fr_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela peut prendre une minute - nous calculons des mises en page intelligentes pour vos photos.`)
};

const de_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das kann eine Minute dauern - wir berechnen intelligente Layouts für Ihre Fotos.`)
};

const ja_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分ほどかかる場合があります - 写真のスマートレイアウトを計算しています。`)
};

const zh_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这可能需要一分钟 - 我们正在为您的照片计算智能排版。`)
};

const ar_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قد يستغرق هذا دقيقة - نحن نحسب التخطيطات الذكية لصورك.`)
};

const id_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini mungkin memakan waktu semenit - kami sedang menghitung tata letak cerdas untuk foto Anda.`)
};

const it_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrebbe volerci un minuto: stiamo calcolando i layout intelligenti per le tue foto.`)
};

const ru_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это может занять минуту — мы рассчитываем умные макеты для ваших фото.`)
};

const pt_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto pode demorar um minuto - estamos a calcular layouts inteligentes para as suas fotos.`)
};

const ko_this_can_take_a_minute_we_are_calculating_smart_la = /** @type {(inputs: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠시만 기다려 주세요 - 사진을 위한 스마트 레이아웃을 계산 중입니다.`)
};

/**
* | output |
* | --- |
* | "This can take a minute - we are calculating smart layouts for your photos." |
*
* @param {This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const this_can_take_a_minute_we_are_calculating_smart_la = /** @type {((inputs?: This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Can_Take_A_Minute_We_Are_Calculating_Smart_LaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "es") return es_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "fr") return fr_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "de") return de_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "ja") return ja_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "zh") return zh_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "ar") return ar_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "id") return id_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "it") return it_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "ru") return ru_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	if (locale === "pt") return pt_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
	return ko_this_can_take_a_minute_we_are_calculating_smart_la(inputs)
});